import * as actions from 'actions';

const INITIAL_STATE = {
  isFetching: false,
  links: []
};

export default (state = INITIAL_STATE, action) => {
  switch(action.type) {
    case actions.LINKS_FETCH: {
      return {
        ...state,
        isFetching: true
      };
    }

    case actions.LINKS_FETCH_ERROR: {
      return {
        ...state,
        isFetching: false
      };
    }

    case actions.LINKS_FETCH_SUCCESS: {
      return {
        ...state,
        isFetching: false,
        links: action.result
      };
    }

    default:
      return state;
  }
};



/** WEBPACK FOOTER **
 ** ./src/members/state/links/reducer.js
 **/